import React from "react";
import { getIsAvailable } from "../Components/Api/headless";
import { useAppDispatch } from "../redux-stores/hooks/hooks";
import { setAvailable } from "../redux-stores/reducers/ConversationState";
import { addToast } from "../redux-stores/reducers/ToastState";
export const useCoreAvailability = (
  intervalDelta: number = 20_000,
  toastDuration: number = 6_000
) => {
  const dispatch = useAppDispatch();

  const runCheck = async () => {
    const v = await getIsAvailable();
    if (!v.data.available) {
      dispatch(
        addToast({
          bg: "Info",
          body: "We are sorry but no agents are currently available\nbut don't worry we keep looking",
          duration: toastDuration,
          header: "Agents are busy",
          timestamp: Date.now(),
        })
      );
    }
    dispatch(setAvailable(v.data.available));
    return v.data.available;
  };

  React.useEffect(() => {
    const interval = setInterval(() => {
      runCheck();
    }, Math.max(10_000, intervalDelta));
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [intervalDelta]);
  return runCheck;
};
